import type { LabV2Popup } from 'lib/labV2/popups'
import { renderInlineMarkdown } from 'lib/string/markdownUtils'
import Label from 'LuxKit/Label'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'
import { useMemo } from 'react'
import { StyledModal, LAB_MODAL_POPUP_DARK_CLASS_NAME } from './ModalPopupsGate'

const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

const POPUP_IMAGE_PARAMS = { mobileAspectRatio: '2:1', tabletAspectRatio: '2:1', desktopAspectRatio: '2:1' } as const

interface Props {
  popup: Pick<LabV2Popup, 'style' | 'content'>
}

export default function LabV2PopupModal({ popup }: Props) {
  const { content } = popup
  const image = useMemo(() => content.imageId ? { id: content.imageId, title: content.title } : undefined, [content.imageId, content.title])
  const titleMarkup = useMemo(() => ({ __html: renderInlineMarkdown(content.title) }), [content.title])
  const descriptionMarkup = useMemo(() => ({ __html: renderInlineMarkdown(content.description ?? '') }), [content.description])
  return (
    <StyledModal
      className={popup.style === 'dark' ? LAB_MODAL_POPUP_DARK_CLASS_NAME : undefined}
      title=""
      isHeaderOverlay
      image={image}
      imageParams={content.imageId ? POPUP_IMAGE_PARAMS : undefined}
      primaryActionText={content.primaryCta?.label}
      primaryActionTo={content.primaryCta?.path}
      secondaryActionText={content.secondaryCta?.label}
      secondaryActionTo={content.secondaryCta?.path}
    >
      <ContentStack>
        {content.tag ? <Label kind="primary" variant={content.tag.variant}>{content.tag.text}</Label> : null}
        <Heading variant="heading3" dangerouslySetInnerHTML={titleMarkup} />
        {content.description ? (
          <BodyText variant="large" dangerouslySetInnerHTML={descriptionMarkup} />
        ) : null}
      </ContentStack>
    </StyledModal>
  )
}
